export const list = state => state.communitiesList;
export const active = state => state.activeCommunity;
export const activeUser = state => state.activeUser;
export const activeCommunityUser = state => state.activeCommunityUser;
export const asidePostsList = state => state.asidePosts;
export const asidePostsCounter = state => state.totalAsidePosts;
export const postsList = state => state.posts;
export const postsCounter = state => state.totalPosts;
export const activePost = state => state.activePost;
export const postsOrderBy = state => state.postsOrderBy;
export const postComments = state => state.postComments;
export const postCommentsCounter = state => state.postTotalComments;
export const activeComment = state => state.activeComment;
export const activeTerms = state => state.activeCommunityTerms;
export const commentReplies = state => commentId => state.commentReplies[commentId] || [];
export const newCommentReplies = state => commentId => state.newCommentReplies[commentId] || [];
export const tags = state => state.tags;
export const popularTags = state => state.popularTags;
export const postFilter = state => state.postFilter;
export const postActiveUpload = state => state.postActiveUpload;
export const comments = state => state.comments;
export const totalComments = state => state.totalComments;
export const mobileSidebar = state => state.mobileSidebar;
export const usersList = state => state.users;
export const totalUsers = state => state.totalUsers;
export const userFilter = state => state.userFilter;
export const usersOrderBy = state => state.usersOrderBy;
export const usersCount = state => state.users.length;
export const activeUserNotifications = state => state.activeUserNotifications;
export const totalNotifications = state => state.totalNotifications;
export const communityUserProfile = state => state.communityUserProfile;
export const badges = state => state.badges;
export const replyingComment = state => state.replyingComment;



// WEBPACK FOOTER //
// ./src/screens/Community/store/getters.js